import { ViewSlip as SharedViewSlip } from '@features/view-slip';

type IProps = {
  orderId: string;
};

export const ViewSlip = ({ orderId }: IProps) => {
  return <SharedViewSlip entityId={orderId} entityType='order' />;
};
